import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { adminRoles, clientRoles } from '@interfaces/auth.interfaces';
import { ThemeService } from '@services/theme.service';
import { IAuthConfig } from '@shared/system-config/system-config.interface';

export const authGuard: CanActivateFn = (route, state) => {
  const themeService = inject(ThemeService);

  const router = new Router;
  const userItem = sessionStorage.getItem('user');
  const user = userItem ? JSON.parse(userItem) : null;
  const permissions = themeService.getPermissions();

  const themeAdminRoles = permissions().filter((item: IAuthConfig) => item.type === 'ADMIN').map((item: IAuthConfig) => item.role);
  const themeClientRoles = permissions().filter((item: IAuthConfig) => item.type === 'CLIENT').map((item: IAuthConfig) => item.role);

  if (permissions().length) {
    if (themeAdminRoles.some((item: string) => user?.authorities?.includes(item))) {
      return true;
    }
  
    if (themeClientRoles.some((item: string) => user?.authorities?.includes(item)) && !user.confirmPersonalData) {
      return false;
    }
  } else {
    if (adminRoles.some((item: string) => user?.authorities?.includes(item))) {
      return true;
    }
    if (clientRoles.some((item: string) => user?.authorities?.includes(item)) && !user.confirmPersonalData) {
      return false;
    }
  }

  router.navigate(['/']);
  return false;
};
